import moment from "moment";
import { EMAIL_LOG_LIST_URL, GET_OFFLINE_JOBS_LOG_HISTORY_URL, GET_OFFLINE_STATUS_JOBS_URL, GET_TOGGLE_OFFLINE_STATUS_URL, PULL_SFTP_FILE_MANUALLY_V2_URL, SFTP_CLIENT_LIST_URL, SFTP_LOG_LIST_URL, GET_REJECT_HISTORY_URL, HOUSE_KEEPING_LOG_LIST_URL, PULL_SFTP_FILE_MANUALLY_V3_URL, RESET_SFTP_FILE_MANUALLY_V3_URL, AUTOMATION_LOG_LIST_URL, 
AUTOMATED_SFTP_LOG_LIST_URL, RESET_SFTP_FILE_MANUALLY_V4_URL, AUTOMATED_SFTP_LOG_DETAIL_URL, AUTOMATED_SFTP_LOG_STATUS_UPDATE_URL, AUTOMATED_SFTP_EMAIL_LOG_DETAIL_URL, GET_FILE_ARRIVALS, FILE_ARRIVAL_AUTO_TRIGGER, AUTOMATED_SFTP_LOG_RECALL_URL, GET_SCHEDULER_LOG_URL, DETECT_FILE_ARRIVALS,
GET_NPI_TIN_LOG_URL, GET_EXCLUDED_PAYER_LOG_URL, GET_ALLOWED_VALUES_LOG_URL, GET_HOLIDAY_CALENDER_LOG_URL, GET_REJECTION_REASON_LOG_URL, GET_X12_CODE_LOG_URL, GET_DOCUMENT_CLASSIFICATION_LOG_URL, GET_PAYER_ID_LIST_LOG_URL, GET_INCOMPLETE_STATUS_LOG_URL, REJECT_JOB_URL,FILE_TRANSFER_LIST_URL,TRANSFER_SCHEDULER_RE_TRIGGER_URL,FILE_TRANSFER_SCHEDULER_LOGS_URL,FILE_TRANSFER_SCHEDULER_LOGS_URL_V1, DOWNLOAD_FULL_S3_URL, GET_LOCKBOX_AVAILABLE_OUTPUTS, FILE_MERGE_SCHEDULER_LOGS_URL, FILE_MERGE_SCHEDULER_LOG_DETAIL_URL } from "../../api";
import axiosInstance from "../../axiosInstance";


export const getSFTPLogListData = (props) => onResponse => {

    try {
        const search = props?.search ? props?.search : "";
        // const filename = filename ? filename : "";
        const client = props?.client ? props?.client : "";
        const deposit_date_range = props?.deposit_date_range ? props?.deposit_date_range : "";
        const status = props?.status ? props?.status : "";
        const facility = props?.facility ? props?.facility : "";

        axiosInstance.get(SFTP_LOG_LIST_URL + "?page=" + props?.page + "&limit=" + props?.page_limit
            + "&search=" + search + "&client=" + client +"&facility=" + facility +  "&deposit_date_range=" + deposit_date_range + "&status=" + status
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getHouseKeepingLogListData = (props) => onResponse => {

    try {
        console.log(props);
        const search = props?.search ? props?.search : "";
        const status = props?.status ? props?.status : "";
        const deposit_date_range = props?.deposit_date_range ? props?.deposit_date_range : "";

        axiosInstance.get(HOUSE_KEEPING_LOG_LIST_URL + "?page=" + props?.page + "&limit=" + props?.page_limit
            + "&search=" + search + "&deposit_date_range=" + deposit_date_range + "&log_type=" + status
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getEmailLogListData = (props) => onResponse => {

    try {
        console.log(props);
        const search = props?.search ? props?.search : "";
        // const filename = filename ? filename : "";
        const client = props?.client ? props?.client : "";
        const email_type = props?.email_type ? props?.email_type : "";
        const sent_status = props?.status && props?.status == 'sent' ? true : props?.status && props?.status == 'failed' ? false : "";
        const deposit_date_range = props?.deposit_date_range ? props?.deposit_date_range : "";


        axiosInstance.get(EMAIL_LOG_LIST_URL + "?page=" + props?.page + "&limit=" + props?.page_limit
            + "&client=" + client +  "&email_type=" + email_type + "&sent_status=" + sent_status + "&deposit_date_range=" + deposit_date_range
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};




// encounter list 835
export const getSFTPClientListData = (props) => onResponse => {
    try {
        // let base_uri = `${SFTP_CLIENT_LIST_URL}?`
        let order = ""
        let column = ""

        if (props?.order !== undefined) {
            order = props?.order
        }
        if (props?.column !== undefined) {
            column = props?.column
        }
         const search = encodeURIComponent(props.search ? props.search : "");
        // axiosInstance.get(SFTP_CLIENT_LIST_URL + "?page=" + props.page + "&limit=" + props.pageLimit + "&search=" + props.search + "&sort_order=" + order + "&sort_key=" + column)

            axiosInstance.get(`${SFTP_CLIENT_LIST_URL}?page=${props.page}&limit=${props.pageLimit}&search=${search}&sort_order=${order}&sort_key=${column}`)
            // axiosInstance.get(SFTP_CLIENT_LIST_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }
};

// offline status list
export const getOfflineStatusData = (props) => onResponse => {
    try {
        // let base_uri = `${SFTP_CLIENT_LIST_URL}?`

        axiosInstance.get(GET_OFFLINE_STATUS_JOBS_URL + "?page=" + props.page + "&limit=" + props.pageLimit + "&search=" + props.search)
            // axiosInstance.get(SFTP_CLIENT_LIST_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }
};

export const getOfflineJobLogHistory = (periodic_task) => onResponse => {
    try {
        axiosInstance.get(GET_OFFLINE_JOBS_LOG_HISTORY_URL + "?periodic_task=" + periodic_task)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getRejectHistory = (sftp_id) => onResponse => {
    try {
        axiosInstance.get(GET_REJECT_HISTORY_URL + "?sftp_id=" + sftp_id)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getRejectLockBoxFile = ({pk,comment}) => onResponse => {
    try {
        axiosInstance.post(REJECT_JOB_URL, { pk, comment:comment })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {
        console.error(error)
    }

};
 

export const toggleOfflineStatus = (props) => onResponse => {
    try {
        axiosInstance.post(GET_TOGGLE_OFFLINE_STATUS_URL, props.formData)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

// encounter list 835
export const pullSFTPFileManually = (props) => onResponse => {
    try {
        axiosInstance.post(PULL_SFTP_FILE_MANUALLY_V3_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }
};
export const resetSFTPFileManually = (props) => onResponse => {
    try {
        axiosInstance.post(RESET_SFTP_FILE_MANUALLY_V4_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }
};

export const getAutomationLogListData = (props) => onResponse => {

    try {
        const users = props?.users ? props?.users : [];
        const clients = props?.client ? props?.client : [];
        const deposit_date_range = props?.deposit_date_range ? props?.deposit_date_range : "";
        const type = props?.type ? props?.type : "";

        axiosInstance.get(AUTOMATION_LOG_LIST_URL + "?page=" + props?.page + "&limit=" + props?.page_limit
            + "&users=" + users + "&deposit_date_range=" + deposit_date_range+ "&clients=" + clients+ "&type=" + type 
        )
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getAutomtedSFTPLogListData = (props) => onResponse => {
    let formattedDepositDateRange=''

    try {
        axiosInstance.get(AUTOMATED_SFTP_LOG_LIST_URL, {
            params: {
                page: props?.page,
                limit: props?.limit,
                file_name: props?.file_name || "",
                client: Array.isArray(props?.client) ? props.client.join(',') : props?.client || "",
                facility: Array.isArray(props?.facility) ? props.facility.join(',') : props?.facility || "",
                received_date_range: props?.created_date  || "",
                status: Array.isArray(props?.status) ? props.status.join(',') : props?.status || "",
                user: Array.isArray(props?.user) ? props.user.join(',') : props?.user || "",
                reset_user: Array.isArray(props?.reset_user) ? props.reset_user.join(',') : props?.reset_user || "",
                file_type: props?.fileType || "",
                directory : props?.directory || '', 
                is_excluded : props?.is_error_occured , 
                sort_key: props?.sort_key || "",
                sort_order: props?.sort_order || "",
                is_from_alerts: props?.is_from_alerts || "",
                partner: Array.isArray(props?.partner) ? props.partner.join(',') : props?.partner || ""
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getSFTPLogDetailById = (pk) => (onResponse) => {

   
    try {
        axiosInstance
            .get(`${AUTOMATED_SFTP_LOG_DETAIL_URL}/${pk}`)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.error(err);
                onResponse({ status: false, error: err });
            });


    } catch (error) {

    }

};
export const automateSftplogStatus = ({ids, reason, status}) => onResponse => {
    try {
        axiosInstance.post(AUTOMATED_SFTP_LOG_STATUS_UPDATE_URL, { id  : ids, reason: reason  ,status :status})
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const automateSftplogRecall = ({ids}) => onResponse => {
    try {
        axiosInstance.post(AUTOMATED_SFTP_LOG_RECALL_URL, { id  : ids  })
        .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getSFTPEmailLogDetailById = (pk) => (onResponse) => {

   
    try {
        axiosInstance
            .get(`${AUTOMATED_SFTP_EMAIL_LOG_DETAIL_URL}?id=${pk}`)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.error(err);
                onResponse({ status: false, error: err });
            });


    } catch (error) {

    }

};

export const getFileArrivals = (props) => onResponse => {
    let formattedDepositDateRange=''

    try {
        axiosInstance.get(GET_FILE_ARRIVALS, {
            params: {
                page: props?.page,
                limit: props?.limit,
                file_name: props?.file_name || "",
                client: Array.isArray(props?.client) ? props.client.join(',') : props?.client || "",
                facility: Array.isArray(props?.facility) ? props.facility.join(',') : props?.facility || "",
                received_date_range: props?.created_date  || "",
                status: Array.isArray(props?.status) ? props.status.join(',') : props?.status || "",
                user: Array.isArray(props?.user) ? props.user.join(',') : props?.user || "",
                reset_user: Array.isArray(props?.reset_user) ? props.reset_user.join(',') : props?.reset_user || "",
                file_type: props?.fileType || "",
                directory : props?.directory || '', 
                partner : Array.isArray(props?.partner) ? props.partner.join(',') : props?.partner || "",
                is_from_alerts : props?.is_from_alerts || false, 

            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const fileArrivlAutoTrigger  = (props) => onResponse => {
    let formattedDepositDateRange=''

    try {
        axiosInstance.post(FILE_ARRIVAL_AUTO_TRIGGER, {
           
                id: props?.id,
                 
           
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getSchedulerLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_SCHEDULER_LOG_URL, {
            params: {
                page: props?.page,
                limit: props?.perPage,
                id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getDetectFileArrial = (props) => onResponse => {

    try {
        axiosInstance.post(DETECT_FILE_ARRIVALS)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {
        console.log(error);

    }
}


export const getNpiTinLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_NPI_TIN_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                tin_id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getAllowedValuesLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_ALLOWED_VALUES_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getExcludedPayerLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_EXCLUDED_PAYER_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getX12CodeLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_X12_CODE_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getRejectionReasonLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_REJECTION_REASON_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getHolidayCalendarLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_HOLIDAY_CALENDER_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getDocumentClassificationLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_DOCUMENT_CLASSIFICATION_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                classifications: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getPayerIDListLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_PAYER_ID_LIST_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                payer_list_id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getIncompleteStatusLogs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_INCOMPLETE_STATUS_LOG_URL, {
            params: {
                user: props?.user,
                updated_date_range: props?.updated_date_range,
                page: props?.page,
                limit: props?.perPage,
                id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getFTPTransferSchedulerLogs = (page,limit,props) => onResponse => {
    try {
        axiosInstance.get(FILE_TRANSFER_LIST_URL, {
            params: {
                page: page,
                limit: limit,
                client: Array.isArray(props?.client) ? props.client.join(',') : props?.client || "",
                lockbox_name: props?.lockbox_name || "",
                status: Array.isArray(props?.status) ? props.status.join(',') : props?.status || "",
                created_by: Array.isArray(props?.created_by) ? props.created_by.join(',') : props?.created_by || "",
                is_sent_forcefully: props?.is_sent_forcefully !== undefined && props?.is_sent_forcefully !== "" ? props?.is_sent_forcefully : "",
                initiated_date_range: props?.initiated_date_range || "",
                sort_key: props?.sort_key || "",
                sort_order: props?.sort_order || "",
            }
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.error(err);
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};


export const getFileTransferSchedulerLogs = (props) => onResponse => {

    try {
        axiosInstance.get(`${FILE_TRANSFER_SCHEDULER_LOGS_URL_V1}/${props?.pk}`, {
            params: {
                page: props?.page,
                limit: props?.perPage,
                // id: props?.pk,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const reTriggerTransferScheduler = (payload) => onResponse => {
    try {
        axiosInstance.post(TRANSFER_SCHEDULER_RE_TRIGGER_URL, payload)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.error(err);
                onResponse(err);
            });
    } catch (error) {
        console.error(error);
    }
};

export const downloadFullS3File = (payload) => onResponse => {
    try {
        axiosInstance.post(DOWNLOAD_FULL_S3_URL, payload)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.error(err);
                onResponse(err);
            });
    } catch (error) {
        console.error(error);
    }
};
export const getLockBoxAvailableOutputs = (props) => onResponse => {

    try {
        axiosInstance.get(GET_LOCKBOX_AVAILABLE_OUTPUTS, {
            params: {
                lockbox_id: props?.lockbox_id,
            }
        })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getFileMergeSchedulerLogs = (page, limit, props) => onResponse => {
    try {
        axiosInstance.get(FILE_MERGE_SCHEDULER_LOGS_URL, {
            params: {
                page: page,
                limit: limit,
                partner: Array.isArray(props?.partner) ? props.partner.join(',') : props?.partner || "",
                client: Array.isArray(props?.client) ? props.client.join(',') : props?.client || "",
                facility: Array.isArray(props?.facility) ? props.facility.join(',') : props?.facility || "",
                lockbox_file_name: props?.lockbox_file_name || "",
                file_name: props?.file_name || "",
                status: Array.isArray(props?.status) ? props.status.join(',') : props?.status || "",
                user: Array.isArray(props?.user) ? props.user.join(',') : props?.user || "",
                deposit_date: props?.deposit_date || "",
                initiated_time: props?.initiated_time || "",
                sort_key: props?.sort_key || "",
                sort_order: props?.sort_order || "",
            }
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err);
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};

export const getFileMergeSchedulerLogHistory = ({ page, perPage, pk, user, updated_date_range }) => onResponse => {
    try {
        axiosInstance.get(FILE_MERGE_SCHEDULER_LOGS_URL, {
            params: {
                page: page,
                limit: perPage,
                id: pk,
                user: user,
                updated_date_range: updated_date_range
            }
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err);
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};

export const getFileMergeSchedulerLogDetail = (id) => onResponse => {
    try {
        axiosInstance.get(`${FILE_MERGE_SCHEDULER_LOG_DETAIL_URL}/${id}`)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) {
        console.error(error);
    }
};